import moment from 'moment';

// The API stores start/end in UTC but reads and writes them as SGT wall-clock
// time, so the picker must show SGT regardless of the browser timezone.
const SGT_UTC_OFFSET_MINUTES = 8 * 60;

const SGT_PAYLOAD_FORMAT = 'YYYY-MM-DD HH:mm:ss';

const HAS_UTC_OFFSET = /(Z|[+-]\d{2}:?\d{2})$/;

// -> moment showing the value in SGT. Two kinds of input arrive here: an
// absolute instant from the API ("...Z"), and our own offset-less payload
// still sitting in redux after a picker change. The latter is already SGT
// wall-clock time, so its digits must be kept rather than reinterpreted as
// browser-local time — otherwise the picker shifts by the browser's offset
// from SGT on every change.
export const toSgtMoment = (value) => {
  if (!value) {
    return null;
  }
  if (typeof value === 'string' && !HAS_UTC_OFFSET.test(value)) {
    return moment(value, SGT_PAYLOAD_FORMAT).utcOffset(
      SGT_UTC_OFFSET_MINUTES,
      true
    );
  }
  return moment(value).utcOffset(SGT_UTC_OFFSET_MINUTES);
};

// Picker moment -> string without offset, which the API reads as SGT.
export const toSgtPayload = (momentValue) => {
  if (!momentValue) {
    return null;
  }
  return momentValue.format(SGT_PAYLOAD_FORMAT);
};
